import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

import {
  STORYBLOK_PRODUCT_SEARCH_FILTERS_TO_QUERY_MAPPER,
  type StoryblokProductSearchFilterToQueryMapperType,
} from './STORYBLOK_PRODUCT_SEARCH_FILTERS_TO_QUERY_MAPPER'

/**
 * Builds a Storyblok product search query string from filter values.
 *
 * Each provided filter key is looked up in STORYBLOK_PRODUCT_SEARCH_FILTERS_TO_QUERY_MAPPER.
 * If a mapper exists, it is invoked to produce a fragment (e.g. "brand:foo" or a more
 * complex conditional). All successfully mapped fragments are joined with " AND ".
 * Filters without a corresponding mapper are ignored.
 *
 * @example
 * const q = storyblokProductSearchFiltersParseFiltersToQueryString({
 *   categoryCodes: ['nike', 'adidas'],
 *   discountInPercent: { min: 50, max: 150 }
 * })
 * // => "categoryCodes:nike OR categoryCodes:adidas AND (discountInPercent >= 50 AND discountInPercent <= 150)"
 **/
export const storyblokProductSearchFiltersParseFiltersToQueryString = (
  filters: Partial<StoryblokProductSearchFiltersType>,
): string => {
  const queryFilters = Object.entries(filters)
    .map(([fieldName, value]) => {
      if (fieldName in STORYBLOK_PRODUCT_SEARCH_FILTERS_TO_QUERY_MAPPER) {
        const mapper =
          STORYBLOK_PRODUCT_SEARCH_FILTERS_TO_QUERY_MAPPER[
            fieldName as keyof StoryblokProductSearchFilterToQueryMapperType
          ]

        return mapper(fieldName, value as never)
      }

      return null
    })
    .filter(Boolean)

  if (queryFilters.length > 0) {
    return queryFilters.join(' AND ')
  }

  return ''
}
